export default "__VITE_ASSET__2OoeKC0G__"